module.exports = __webpack_public_path__ + "img/chama-violeta.9ff297f6.jpg";